module.exports = __webpack_public_path__ + "static/media/football-carousel.3f13304c.jpg";